import React from "react"
import styled from 'styled-components'

import Guest from './Guest'

const Wrapper = styled.ul`
  display: flex;
  justify-content: flex-start;
  flex-flow: row;
  margin: 0 auto;
`
const List = styled.li`
  max-width: 140px;
  & + & {
    margin-left: 2.0rem;
  }
`

const GuestList = ({ guests }) => {
  return (
    <Wrapper>
      {guests.map((guest, i) => (
        <List key={i}>
          <Guest stats={guest} />
        </List>
      ))}
    </Wrapper>
  )
}

export default GuestList